import { SET_SWITCH_WIDGET_SELECTION } from '../actionTypes/PLPSwitchWidgetActionTypes';

export const setSwitchWidgetSelection = (switchWidgetValue) => ({
    type: SET_SWITCH_WIDGET_SELECTION,
    selectedValue: switchWidgetValue,
});

export default {
    setSwitchWidgetSelection,
};
